import React from "react";
import "./fundwallet.css";
import naira from "../../../../Assets/naira.svg";
import cedis from "../../../../Assets/cedis.svg";
import dollar from "../../../../Assets/dollar.svg";
import { useUser } from "../../../../../hooks/use-user";

const SelectWallet = ({ setStage }) => {
  const user = useUser();
  let walletName = "OVest";
  let icon = naira;

  if (user && user.country) {
    if (user.country.toLowerCase().includes("nigeria")) {
      walletName = "Naira";
    }
    if (user.country.toLowerCase().includes("ghana")) {
      walletName = "Cedis";
      icon = cedis;
    }
  }

  return (
    <div className="select-wallet">
      <h5>Select Wallet</h5>
      <p>choose the wallet you will like to fund.</p>
      <div className="select-wallet-list">
        <div className="naira-wallet">
          <img src={icon} alt="" />
          <p>{walletName} Wallet</p>
          <button
            onClick={() => {
              setStage(1, { selected: "wallet" });
            }}
          >
            {/* this should lead to fund naira wallet */}
            Fund {walletName} Wallet
          </button>
        </div>

        <div className="dollar-wallet">
          <img src={dollar} alt="" />
          <p>Dollar Wallet</p>
          <button
            onClick={() => {
              setStage(1, { selected: "dollar" });
            }}
          >
            {/* this should lead to fund dollar wallet with  nebbix icon */}
            Fund Dollar Wallet
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectWallet;
